import { SortingState } from '@tanstack/react-table';

import { BulkDataTableFilterToQuery, DataTableFilter } from './typings';

export const createPrismaQuery = <Arr extends DataTableFilter[]>(filters: Arr): BulkDataTableFilterToQuery<Arr> => {
  const query = {} as any;

  filters.forEach((filter) => {
    const { name, value, operator } = filter;

    // Only add filters when both value and operator defined
    if (value !== undefined && operator !== undefined) {
      if (!query[name]) {
        query[name] = {};
      }

      if (filter['mode']) {
        query[name] = { [operator]: value, mode: filter['mode'] };
      } else {
        query[name][operator] = value;
      }
    }
  });

  return query;
};

export const createPrismaSort = (sorting: SortingState) => {
  if (!sorting.length) {
    return undefined;
  }
  const transformed: { [key: string]: 'asc' | 'desc' } = {};
  sorting?.forEach((columnSort) => {
    transformed[columnSort.id] = columnSort.desc ? 'desc' : 'asc';
  });

  return transformed;
};
